import { Injectable } from '@angular/core';
import { CredentialsService } from 'src/app/auth';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * This class attaches the auth token to any outgoing request.
 * You can except a particular type of request in the intercept() method
 */
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private credentialsService: CredentialsService) {
  }

  intercept(request: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    const EXCLUDED_URL_PARTS = [
      'saml/exchange/',
      environment.contentLakeBucket,
      `${environment.vendorIntegrationServiceBaseUrl}/pardot`,
      'amazonaws',
      'hygraph.com',
      'v1/search'
    ];

    const isIncluded = (!EXCLUDED_URL_PARTS.some(part => request.url.includes(part)));
    const hasAccessToken = this.credentialsService.getAccessToken() !== null;

    if (isIncluded && hasAccessToken) {
      request = this.setAuthorizationHeader(
        request,
        `Bearer ${this.credentialsService.getAccessToken()}`
      );
    } else if (isIncluded) {
      request = this.setAuthorizationHeader(
        request,
        '1d964f9b299c1304bea62de5ca75837f'
      );
    }
    return next.handle(request);
  }

  private setAuthorizationHeader(request: HttpRequest<any>,
                                 authValue: string) {
    return request.clone(
      {
        setHeaders: {
          Authorization: authValue
        }
      }
    );
  }
}
